
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/p/[url]",
      function () {
        return require("private-next-pages/p/[url].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/p/[url]"])
      });
    }
  